// extracted by mini-css-extract-plugin
export default {"title":"DataModelsIndexPage_title__Z88mQ","header":"DataModelsIndexPage_header__PvFx1","button":"DataModelsIndexPage_button__bY4tA"};